var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-4"},[_vm._m(0),_c('orderDetail',{attrs:{"order_id":_vm.$route.params.orderid}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3"},[_c('span',{staticClass:"main-title"},[_vm._v("ORDER DETAIL")])])
}]

export { render, staticRenderFns }